import React from 'react'
import type { ScheduleJobMember } from './types'
import UserRow from './UserRow'
import type { ScheduleJobDialogClasses } from './useScheduleJobDialogStyles'

interface MemberSelectPanelProps {
  classes: ScheduleJobDialogClasses
  members: ScheduleJobMember[]
  selectedMemberIds: Set<string>
  onToggle: (id: string) => void
  onClear: () => void
  onDone: () => void
}

export default function MemberSelectPanel(props: MemberSelectPanelProps) {
  const { classes, members, selectedMemberIds, onToggle, onClear, onDone } = props

  return (
    <div className={classes.panel}>
      <div className={classes.panelList}>
        {members.map((member) => (
          <UserRow
            key={member.id}
            classes={classes}
            member={member}
            selected={selectedMemberIds.has(member.id)}
            onToggle={() => onToggle(member.id)}
          />
        ))}
      </div>
      <div className={classes.panelFooter}>
        <button className={classes.panelClearBtn} onClick={onClear}>
          Clear
        </button>
        <button className={classes.panelDoneBtn} onClick={onDone}>
          Done
        </button>
      </div>
    </div>
  )
}
